<template>
    <modal name="envelope-document-select-modal"
        :adaptive="true"
        :focusTrap="true"
        :width="800"
        height="auto"
        :scrollable="false"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        @before-close="beforeClose"
    >
        <div class="rounded-lg bg-white px-10 py-8 h-[66vh] flex flex-col">
            <div class="flex-shrink-0 text-blue-600 text-lg font-semibold leading-none mb-6">
                Select Documents for this Envelope:
            </div>

            <div class="border border-gray-300 overflow-y-auto flex-1 min-h-0 mb-4">
                <div v-for="(folder, index) in folders_with_content"
                    :key="folder.id"
                     class="border-b border-gray-300"
                     :data-folder-id="folder.id"
                >
                    <document-folder
                        :folder="folder"
                        :property_id="property.id"
                        :documents="getDocumentsForFolder(folder.id)"
                        :templates="getTemplatesForFolder(folder.id)"
                        :has_active_docusign_user="true"
                        :selection_mode="true"
                        :selected_documents="selected_documents"
                        :hide_upload_button="true"
                        :hide_drag_handle="true"
                        :disable_contextual_menus="true"
                        :is_editable="false"
                        @selection-changed="handleSelectionChanged"
                    />
                </div>
            </div>

            <div class="flex items-center justify-end pt-4 flex-shrink-0">
                <button-blue @click="done">
                    Done
                </button-blue>
            </div>
        </div>
    </modal>
</template>

<script>
import { FolderIcon, FileIcon } from 'vue-feather-icons';
import { FileTextIcon } from 'vue-feather-icons';
import DocumentFolder from '../document-folder.vue';
import ButtonBlue from '../../../components/button-blue.vue';
import axios from 'axios';

export default {
    components: {
        FolderIcon,
        FileIcon,
        FileTextIcon,
        DocumentFolder,
        ButtonBlue,
    },

    props: {
        show: {},
        property_id: { required: true },
        property: {},
        envelope_documents: { default: () => [] },
        documents: { default: () => [] },
        templates: { default: () => [] },
        document_folders: { default: () => [] },
    },

    data() {
        return {
            selected_documents: [],
        }
    },

    computed: {
        folders_with_content() {
            return this.document_folders.filter(folder => {
                const folderDocuments = this.getDocumentsForFolder(folder.id);
                const folderTemplates = this.getTemplatesForFolder(folder.id);
                return folderDocuments.length > 0 || folderTemplates.length > 0;
            });
        },
    },

    methods: {
        beforeOpen() {
            this.selected_documents = [...this.envelope_documents];
        },
        beforeClose(event) {
            this.$emit('closed');
        },
        done() {
            this.$emit('selected', this.selected_documents);
            this.$modal.hide('envelope-document-select-modal');
        },
        handleSelectionChanged(selected) {
            this.selected_documents = selected;
        },
        getDocumentsForFolder(folder_id) {
            return this.documents.filter(document => document.folder_id == folder_id);
        },
        getTemplatesForFolder(folder_id) {
            const folder = this.document_folders.find(folder => folder.id == folder_id);

            if (! folder || ! folder.default_folder_id) {
                return [];
            }

            return this.templates.filter(template => template.folder_id == folder.default_folder_id);
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.beforeOpen();
                this.$modal.show('envelope-document-select-modal');
            } else {
                this.$modal.hide('envelope-document-select-modal');
            }
        },
    },
}
</script>
